import { HeadSection } from 'components/HeadSection';
import { useTenantConfig } from 'contexts';
import { useIdentifiedPage } from 'hooks';
import dynamic from 'next/dynamic';
import React, { useEffect } from 'react';
import { CustomHomeProps } from './CustomHome';
import { DefaultHomeProps } from './DefaultHome';

const DefaultHome = dynamic(() =>
  import('./DefaultHome').then((mod) => mod.DefaultHome),
);
const CustomHome = dynamic(() =>
  import('./CustomHome').then((mod) => mod.CustomHome),
);

export type HomeProps = CustomHomeProps & DefaultHomeProps;

export const Home: React.FC<HomeProps> = ({
  areas,
  menuItems,
  ...defaultHomeProps
}: HomeProps) => {
  const { allowRenderCustomPage, baseDomain } = useTenantConfig();

  useIdentifiedPage('homePage');

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeadSection canonical={baseDomain} />
      {allowRenderCustomPage ? (
        <CustomHome areas={areas} menuItems={menuItems} />
      ) : (
        <DefaultHome menuItems={menuItems} {...defaultHomeProps} />
      )}
    </>
  );
};
